import React from 'react';
import { graphql } from 'gatsby';
import { PromoBanner as PromoBannerComponent } from '../../../promoBanner/PromoBanner';

export const PromoBanner = ({ data, ...rest }) => (
  <PromoBannerComponent
    {...data}
    {...rest}
    image={data.image?.image?.localFile}
  />
);

export const PromoBannerQuery = graphql`
  fragment PromoBanner on UMBRACO_PromoBannerComponentType {
    heading
    description
    buttonOne {
      ...Link
    }
    buttonTwo {
      ...Link
    }
    image {
      image {
        ...PromoBannerImage
      }
    }
  }
`;
